<h1>Organizations</h1>

<div *ngIf="!(isLoading$ | async)">

  <div *ngIf="((ownedOrganizations$ | async)?.length ?? 0) > 0">
    <div class="flex flex-col lg:flex-row mb-5">
      <div class="grow">
        <h2>Owned by you</h2>
      </div>
      <div class="">
        <p-button (click)="refreshOrgs()" severity="secondary" icon="bi-arrow-clockwise" label="Refresh" class="mr-3"></p-button>
        <p-button (onClick)="showOrganizationForm(null)" severity="primary" icon="bi-plus-circle" label="Create Org"></p-button>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 items-stretch">
      <div *ngFor="let org of (organizations$ | async)" class="rounded-lg bg-gray-800 px-5 py-7 text-center">
        <div class="p-0 m-0 text-4xl site-font">{{ org.name }}</div>
        <div>{{ org.game }}</div>
        <div class="flex flex-col lg:flex-row justify-center gap-3 mt-5">
          <!--*ngIf="(currentOrg$ | async)?.id !== org.id"-->
          <p-button (onClick)="selectOrg(org.id)" severity="primary" label="Select"></p-button>
          <p-button (onClick)="openPublicPage(org.slug!)" severity="info" label="Public page"></p-button>
          <p-button (onClick)="showAdminsForm(org)" severity="help" icon="bi-person-badge-fill" label="Admins"></p-button>
          <p-button (onClick)="showOrganizationForm(org)" severity="warn" icon="bi-pencil-square" label="Edit"></p-button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="((adminOrganizations$ | async)?.length ?? 0) > 0">
    <div class="flex mb-5">
      <div class="grow">
        <h2>Organizations You're Helping</h2>
      </div>
      <div class="">
        <p-button (click)="refreshOrgs()" severity="secondary" icon="bi-arrow-clockwise" label="Refresh" class="mr-3"></p-button>
        <p-button (onClick)="showOrganizationForm(null)" severity="primary" icon="bi-plus-circle" label="Create Organization"></p-button>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 items-stretch">
      <div *ngFor="let org of (organizations$ | async)" class="rounded-lg bg-gray-800 px-5 py-7 text-center">
        <div class="p-0 m-0 text-4xl site-font">{{ org.name }}</div>
        <div>{{ org.game }}</div>
        <div class="flex justify-center gap-3 mt-5">
          <!--*ngIf="(currentOrg$ | async)?.id !== org.id"-->
          <p-button (onClick)="selectOrg(org.id)" severity="primary" label="Select"></p-button>
          <p-button (onClick)="openPublicPage(org.slug!)" severity="info" label="Public page"></p-button>
        </div>
      </div>
    </div>
  </div>

</div>

<tr-alert *ngIf="!(isLoading$ | async) && ((organizations$ | async)?.length ?? 0) === 0" severity="primary" class="text-center">
  <p class="text-xl">
    You don't have any organizations!
  </p>
  <p-button (onClick)="showOrganizationForm(null)" severity="secondary" icon="bi-plus-circle" label="Add organization"></p-button>
</tr-alert>

<div *ngIf="(isLoading$ | async)">
  <tr-alert severity="warning" class="text-center">
    <span class="m-0 p-0 text-4xl site-font">Loading organizations</span>
  </tr-alert>
</div>